module.exports = __webpack_public_path__ + "img/1-6.37598f96.png";